import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsAmazonVendor() {
  return (
    <IntegrationDocTemplate
      title="Amazon Vendor Central (EDI)"
      category="Marketplace · Wholesale"
      status="live"
      summary="If you sell wholesale TO Amazon (not via Seller Central), you need EDI compliance — 850 (PO), 855 (PO Ack), 856 (ASN within 30 min of ship), 810 (Invoice). Over AS2 with MDN. We handle GS1-128 SSCC labels and FSMA 204 KDEs for food/beverage."
      prerequisites={[
        'Amazon Vendor Central account with EDI compliance enabled.',
        'AS2 communication credentials from Amazon (URL + certificates).',
        'Trading partner ID from Amazon (typically your DUNS number).',
      ]}
      connectSteps={[
        'Send us your AS2 endpoint and certificates via Talk to Sales.',
        'Our team mirrors the AS2 trading-partner config into our EDI module.',
        'First test 855 round-trip to Amazon test environment within 24 hours.',
        'Production cut-over after a 1-week parallel run with zero discrepancies.',
      ]}
      syncedData={[
        { type: '850 (PO)', detail: 'Inbound from Amazon — parsed into purchase orders' },
        { type: '855 (PO Ack)', detail: 'Outbound — auto-acknowledge within 24h (or proposed changes)' },
        { type: '856 (ASN)', detail: 'Outbound — must send 30 min before ship; SSCC labels + carton hierarchy' },
        { type: '810 (Invoice)', detail: 'Outbound — must match 856 line-by-line; auto-generated post-shipment' },
        { type: '997 (Functional Ack)', detail: 'Bidirectional — confirms EDI document receipt' },
      ]}
      agents={[
        { id: 'po_agent', name: 'po_agent', role: '850 parsing + 855 acknowledgement' },
        { id: 'asn_agent', name: 'asn_agent', role: '856 generation with FSMA 204 KDEs' },
        { id: 'invoice_match_agent', name: 'invoice_match_agent', role: '810 generation + 3-way match' },
      ]}
      troubleshooting={[
        { question: 'AS2 MDN not received', answer: 'Check certificate expiry first. Our MIC (SHA-256) is in the sync_log; share with Amazon EDI support to resolve.' },
        { question: 'ASN chargeback risk warning', answer: 'Pre-flight validator flagged a likely-error (missing SSCC, wrong BOL, late timing). Fix before submit — chargebacks are 3% COGS minimum.' },
        { question: 'FSMA 204 KDE missing', answer: 'For food/beverage shipments since Aug 2025 you must include lot_number + expiration in 856 LIN/REF/DTM segments. Update item master via /catalog.' },
      ]}
      supportLink="/contact"
    />
  );
}
